import { IBase } from "./Base";
import { Field } from "./Field";
import { IRelationship } from "./Relationship";

export interface IEntity extends IBase {
  name: string;
  fields: Field[];
  source_relationships: IRelationship[];
  target_relationships: IRelationship[];
  enable_rls: boolean;
  is_junction: boolean;
  is_system: boolean;
  is_public: boolean;
  lock_new_records: boolean;
  sort_order: number;
  indexing_status: EntityIndexingStatus;
  last_indexed_at: string | null;
}

export type UpdateEntity = {
  name: string;
  enable_rls: boolean;
  locked: boolean;
  is_public: boolean;
  lock_new_records: boolean;
};

export type CreateEntity = UpdateEntity & {
  add_to_my_menu_automatically: boolean;
  menu_icon?: string;
};

export type EntityFieldTree = {
  name: string;
  path: string;
  definition: Field;
  children: EntityFieldTree[];
};

export enum EntityIndexingStatus {
  Idle = 0,
  PendingIndex = 1,
  InProgress = 2,
  Failed = 3,
}
